import { createSelector } from "reselect";

import { getLabels, getSundryTemplates } from "../root";

// The shape of a row in the Sundry Templates table.
export interface SundryTemplateAggridRow {
  sundryTemplate: SundryTemplate;
  labels?: string[];
}

export const selectSundryTemplatesAggridData = createSelector(
  [getSundryTemplates, getLabels],
  (sundryTemplatesByIdLookup, labelsLookup) =>
    Object.values(sundryTemplatesByIdLookup).map(
      (sundryTemplate: SundryTemplate): SundryTemplateAggridRow => ({
        sundryTemplate,
        labels: sundryTemplate.labels?.map(l => labelsLookup[l]?.name) || [],
      }),
    ),
);
